(ns ycweb.app.website.footer.newslettersignup
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.app.pos.voucher.voucher :as voucher]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(def three-or-more-uuid #uuid"f53fddbe-8eda-4776-99ac-62096742b7c1")

(rum/defc newsletter-signup-body < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        newsletters-atom (rum/cursor-in process-atom [:newsletters])
        three-or-more-atom (rum/cursor-in newsletters-atom [three-or-more-uuid :interest/selected?])
        special-interests-atom (rum/cursor-in process-atom [:special-interests])
        special-interests (rum/react special-interests-atom)
        error (cmn/curact process-atom :error)]

    [:div.modal__content
     (headings/heading "Newsletter and personalised offers signup" {:type :h2 :size :medium})
     [:div
      [:form.form.u-max-width-640
       [:div

        (when error
          (feedback/feedback :error error))

        [:div.u-max-width-480
         (forms/input "Email:" "e.g. jane.smith@domain.com"
           (rum/cursor-in process-atom [:user :user/email])
           {:type :email
            :onblur-fn #(grid/dispatch-action app-atom :web.footer/newsletter-signup-email {})})]

        (headings/heading "Receive these mails…"
          {:type :h3 :size :small})]

       [:div.u-margin-top-30
        {:class (u/bem :form-section [:lined])}
        [:label.form-field.toggle-label
         {:for (str "special-interests-surveys-footer" "newsletter") :key "newsletter"}
         [:input.toggle
          (merge
            (input-forms/checkbox-props
              three-or-more-atom
              #(grid/dispatch-action app-atom :web.footer/newsletter-choose-interest {:special-interests-labels ["Personalised offers"]})
              nil
              false
              false)
            {:id (str "special-interests-surveys-footer" "newsletter")})]
         [:span.toggle__graphic-wrapper
          [:span.toggle__graphic]]
         [:span.toggle__text
          [:span.toggle__title "Newsletters and personalised offers"]
          [:span "Find out first about new launches and deals, plus the chance to receive occasional vouchers"]]]
        (map
          (fn [[uuid interest]]
            [:label.form-field.toggle-label
             {:for (str "special-interests-surveys-footer" uuid) :key uuid}
             [:input.toggle
              (merge
                (input-forms/checkbox-props
                  (rum/cursor-in special-interests-atom
                    [uuid :interest/selected?])
                  nil
                  nil
                  (rum/react three-or-more-atom)
                  false)
                {:id (str "special-interests-surveys-footer" uuid)})]
             [:span.toggle__graphic-wrapper
              [:span.toggle__graphic]]
             [:span.toggle__text
              [:span.toggle__title
               (when (= (:ent/display-name interest) "Personalised offers")
                 "Personalised offers only")]
              (when (= (:ent/display-name interest) "Personalised offers")
                [:span "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"])]])
          special-interests)]]

      (buttons/button-web "Submit"
        {:on-click #(grid/dispatch-action app-atom :web.footer/newsletter-signup-save {})
         :type :button
         :disabled (or error (cmn/curact app-atom [:submitting?]))
         :style :primary
         :size :default})]
     (toaster/loading-overlay app-atom :web.footer/newsletters-overlay)]))

(defmethod grid/action :web.footer/newsletter-choose-interest [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        special-interests-atom (rum/cursor-in process-atom [:special-interests])
        newsletters-atom (rum/cursor-in process-atom [:newsletters])
        newsletter-interest
        (->>
          @newsletters-atom
          (vals)
          (filter :interest/selected?)
          (map :ent/uuid)
          (remove nil?)
          (first))
        special-interests-labels (set (:special-interests-labels config))
        interests-to-select (filter #(contains? special-interests-labels (:ent/display-name %)) (vals @special-interests-atom))
        final-interests (map #(assoc % :interest/selected? true) interests-to-select)
        process-name (cmn/process-name app-atom)]
    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (assoc-in [:user :user/newsletter :ent/uuid] newsletter-interest)
          (update :special-interests
            (fn [special-interests]
              (if (not (nil? newsletter-interest))
                (reduce
                  (fn [acc interest]
                    (assoc acc (:ent/uuid interest) interest))
                  special-interests final-interests)
                special-interests))))))))

(defmethod grid/action :web.footer/newsletter-signup-email [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        email (u/presence (cmn/curact process-atom [:user :user/email]))
        last-checked-email (cmn/curact process-atom :last-checked-email)

        valid-email?
        (->>
          email
          (str)
          (re-matches voucher/email-validate))]

    (when (not= email last-checked-email)
      (swap!
        (cmn/process-cursor app-atom) assoc
        :error
        (when-not (and email valid-email?)
          "Please make sure you have entered a valid email address."))

      (when (and email valid-email?)
        (comms/ajax-post :web.footer/newsletter-signup-email
          {:user/email email})))))

(defmethod comms/receive :web.footer/newsletter-signup-email [app-atom {:keys [error email]}]
  (swap!
    (cmn/process-cursor app-atom) assoc
    :error error
    :last-checked-email email))

(defmethod grid/action :web.footer/newsletter-signup-save [app-atom _ _]
  (when-not (cmn/curact app-atom [:submitting?])
    (swap! app-atom assoc :submitting? true)
    (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
    (let [process-atom (cmn/process-cursor app-atom)
          user-newsletter-label-uuid-atom (rum/cursor-in process-atom [:user :user/newsletter :ent/uuid])
          special-interests-atom (rum/cursor-in process-atom [:special-interests])
          email (rum/cursor-in process-atom [:user :user/email])

          special-interest
          (->>
            @special-interests-atom
            (vals)
            (filter :interest/selected?)
            (map :ent/uuid)
            (remove nil?))]

      (comms/ajax-post :web.footer/save-newsletter-interest
        {:user
         {:user/email @email
          :user/interests
          (conj special-interest @user-newsletter-label-uuid-atom)}}))))

(defmethod grid/action :web.footer/newsletter-signup [app-atom _ _]
  (grid/open-modal app-atom :web.footer/newsletter-signup
    {:config
     {:title "Newsletter Signup:"
      :max-width 640}})
  (toaster/open-overlay app-atom :web.footer/newsletters-overlay)
  (comms/ajax-get :web.footer/newsletters {}))

(rum/defc newsletter-signup-end < rum/reactive [app-atom]
  [:div.modal__content.u-padding-bottom-0
   (feedback/feedback :success
     "You're subscribed!")
   (buttons/button-web "Done"
     {:on-click #(grid/close-modal app-atom)
      :type :button
      :style :primary
      :size :default})])

(defmethod grid/modal-config :web.footer/newsletter-signup-end [_ _ _]
  {:body-raw newsletter-signup-end
   :modal-type :variable
   :max-width 640})

(defmethod comms/receive :web.footer/save-newsletter-interest [app-atom _]
  (swap! app-atom dissoc :submitting?)
  (toaster/close-toast app-atom)
  (grid/close-modal app-atom)
  (grid/open-modal app-atom :web.footer/newsletter-signup-end))

(defmethod comms/receive :web.footer/newsletters [app-atom {:keys [newsletters user special-interests]}]
  (toaster/close-overlay app-atom :web.footer/newsletters-overlay)
  (swap!
    (cmn/process-cursor app-atom) assoc
    :errors nil
    :last-checked-email nil
    :newsletters newsletters
    :user (assoc user :user/email (get-in @app-atom [:user :email]))
    :special-interests special-interests))

(defmethod grid/modal-config :web.footer/newsletter-signup [_ _ _]
  {:body-raw newsletter-signup-body
   :modal-type :variable
   :max-width 640})

(rum/defc newslettersignup < rum/reactive [app-atom]
  [:div.yc-section {:id "js-footer-newsletter"}
   [:div.footer-signup.u-bg-terracotta.u-text-white
    [:div
     {:class (u/bem :flex-grid-group [:valign-middle])}
     [:div
      {:class (u/bem :flex-grid-block [:ml-1-2])}
      [:div.flex-grid-content
       (headings/heading
         (list
           "Sign up to the"
           [:span
            {:class (u/bem :clip-text [:ml] :unclip-text [:l :s])}
            " Yuppiechef"]
           " newsletter")
         {:type :h3 :size :small :flush true})
       [:p
        {:class (u/bem :yc-paragraph [:small :flush])}
        "Be the first to know about deals and new product"
        [:span
         {:class (u/bem :clip-text [:ml] :unclip-text [:l])}
         " release"]
        "s."]]]

     [:div
      {:class (u/bem :flex-grid-block [:ml-1-2])}
      [:div.flex-grid-content
       [:a.input-combo.faux-input-combo
        {:on-click #(grid/dispatch-action app-atom :web.footer/newsletter-signup {})}
        [:div.text-input-wrapper
         [:div
          {:class (u/bem :text-input [:has-icon :email])}
          [:span.faux-input-combo__placeholder
           "e.g. jane.smith@domain.com"]]
         [:i.text-input-icon]]
        (buttons/button-web "Signup"
          {:type :span-button
           :style :primary
           :combo true})]]]]]])